import React from "react";

import { hooks } from "@thelabnyc/thelabui/src/components/ScrollNavMenuBlock";
import { classNames } from "@thelabnyc/thelabui/src/utils/styles";

import { Clickable } from "../Clickables";
import { Svg } from "../Svg";

import styles from "./MenuToggle.module.scss";

export const MenuToggle = (props: {
    isOpen: boolean;
    title: string;
    onToggle: () => void;
}) => {
    const activeItem = hooks.useActiveNavItem();
    return (
        <Clickable
            aria-expanded={props.isOpen}
            aria-controls="mobile-nav-list"
            className={classNames([
                [styles.menuToggle, true],
                [styles.isOpen, props.isOpen],
            ])}
            onClick={props.onToggle}
        >
            {activeItem ? activeItem.name : props.title}
            <Svg name="caret" />
        </Clickable>
    );
};
